import cx from "classnames";
import { useTranslation } from "next-i18next";
import React from "react";
import { Transition } from "react-transition-group";

import styles from "./styles.module.css";

const duration = 200;

const defaultStyle = {
  transition: `opacity ${duration}ms ease`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 0.4 },
  entered: { opacity: 0.4 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

export type DialogBgCloseProps = {
  onClick: () => void;
  label?: string;
  className?: string;
};

export const DialogBgClose = ({
  onClick,
  label = "close_CTA",
  className,
}: DialogBgCloseProps) => {
  const { t } = useTranslation();
  const closeCta = t(label);
  return (
    <Transition timeout={0} in appear>
      {(state) => (
        <button
          className={cx(styles.bg, className)}
          aria-label={closeCta}
          onClick={onClick}
          type="button"
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        />
      )}
    </Transition>
  );
};
